import { FaFile } from "react-icons/fa";

const PreviewTableFour = ({ files }) => {
    return ( 

        <ul className="collection with-header mt-2">
            <li className="collection-header is-size-5">Document</li>
                    <li  className="collection-item">
                        <FaFile   className="mr-3"/>
                        <span>{ files.name }</span>
                    </li>       
        </ul>
     );
}
 
export default PreviewTableFour;